
const services = [
  {
    icon: 'ri-lightbulb-line',
    title: 'Consultation & Strategy',
    description:
      'A dedicated kick-off session to understand your goals, define your audience, and build a tailored Meta ad strategy from the ground up.',
  },
  {
    icon: 'ri-settings-3-line',
    title: 'Full Account Set-Up',
    description:
      'Everything configured correctly from day one — ad account structure, Meta Pixel installation, and all the technical foundations for successful Facebook & Instagram ads.',
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Ongoing Monitoring & Optimisation',
    description:
      'Continuous performance tracking, budget management, and creative testing to keep your paid social campaigns delivering strong results.',
  },
  {
    icon: 'ri-file-chart-line',
    title: 'Reporting & Future-Proofing',
    description:
      'Clear monthly reports with actionable recommendations, so your Meta Ads strategy evolves and stays ahead of the curve.',
  },
];

export default function PackageIncludes() {
  return (
    <section id="package" aria-label="What's Included in Meta Ads Management" className="py-20 bg-gray-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
          Service Includes
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service) => (
            <article
              key={service.title}
              className="flex flex-col items-start bg-white rounded-xl p-6"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-white shadow-sm mb-5">
                <i className={`${service.icon} text-teal-600 text-xl`} aria-hidden="true"></i>
              </div>
              <h3 className="text-sm font-bold text-gray-900 uppercase tracking-wide mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
